import { createTypes, actionCreator } from 'redux-action-creator';
import { parseJSON, handleNetworkError, getCookie } from '../../utils'
import { setInfoKey } from '../../api/information-collection/actions'
import { storeTempCC } from '../payers/actions';


export const virtualCardTypes = createTypes([
        'REQUEST',
        'RECEIVE',
        'ERROR',
        'REQUEST_VERIFICATION',
        'RECEIVE_VERIFICATION',
        'ERROR_VERIFICATION',
        'SUCCESS_VERIFICATION',
        'REMOVE',
        'REQUEST_STATUS',
        'RECEIVE_STATUS',
        'ERROR_STATUS',
        'REQUEST_SAVE',
        'RECEIVE_SAVE',
        'ERROR_SAVE',
        'SUCCESS_SAVE',
    ], 'VIRTUAL_CARD');


export const requestVirtualCardVerification = () => {
    return {
        type: virtualCardTypes.REQUEST_VERIFICATION,
    };
};

export const receiveVirtualCardVerification = (response) => {
    return {
        type: virtualCardTypes.RECEIVE_VERIFICATION,
        data: response,
    };
};

export const receiveVirtualCardVerificationError = (response) => {
    return {
        type: virtualCardTypes.ERROR_VERIFICATION,
        error: response,
    };
};


export const startCardVerification = (cardObj, payerId) => {

    let expDate = cardObj.expiryDate.split('/');
    let expYear = '20'+ expDate[1].replace(/\s/g, "");
    let newCardObj = {
        "cardNumber": cardObj.cardNumber.replace(/\s/g, ""),
        "cvc": cardObj.cvc,
        "expirationMonth": parseInt(expDate[0]),
        "expirationYear": parseInt(expYear)
    }

    return dispatch => {

        const apiUrl = `/api/v1/cardverification/`

        dispatch(requestVirtualCardVerification());

        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-CSRFToken': getCookie("csrftoken"),
        }

        return fetch(apiUrl, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(newCardObj),
            credentials: 'include',
        })
        .then(parseJSON)
        .then(response => {
            if(response.isSuccess === true) {
                let virtualCardObj = {
                    virtualCard: response.virtualCard,
                    cardNumber: newCardObj.cardNumber.substr(newCardObj.cardNumber.length - 4),
                    expirationMonth: newCardObj.expirationMonth,
                    expirationYear: newCardObj.expirationYear,
                }
            }
            try {
                dispatch(receiveVirtualCardVerification(response));
            } catch (e) {
                dispatch(receiveVirtualCardVerificationError(response))
            }
        })
        .catch(handleNetworkError);
    };
};


export const requestVirtualCardRequestStatus = () => {
    return {
        type: virtualCardTypes.REQUEST_STATUS,
    };
};

export const receiveVirtualCardRequestStatus = (response) => {
    return {
        type: virtualCardTypes.RECEIVE_STATUS,
        data: response,
    };
};

export const receiveVirtualCardRequestStatusError = (response) => {
    return {
        type: virtualCardTypes.ERROR_STATUS,
        error: response,
    };
};

export const fetchVirtualCardRequestStatus = (token) => {

    return dispatch => {

        let success = true
        const apiUrl = `/api/v1/cardverification/${token}/status/`

        dispatch(requestVirtualCardRequestStatus());

        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-CSRFToken': getCookie("csrftoken"),
        }

        return fetch(apiUrl, {
            method: 'GET',
            headers: headers,
            credentials: 'include',
        })
        .then(response => {
            if (response.status !== 200) {
                success = false
            }
            return response
        })
        .then(parseJSON)
        .then(response => {
            if (success) {
                dispatch(receiveVirtualCardRequestStatus(response));
            } else {
                dispatch(receiveVirtualCardRequestStatusError(response))
            }
        })
        .catch(handleNetworkError);
    };
};





export const requestVirtualCard = () => {
    return {
        type: virtualCardTypes.REQUEST,
    };
};

export const receiveVirtualCard = (response) => {
    return {
        type: virtualCardTypes.RECEIVE,
        data: response,
    };
};

export const receiveVirtualCardError = (response) => {
    return {
        type: virtualCardTypes.ERROR,
        error: response,
    };
};

export const removeVirtualCard = () => {
    return {
        type: virtualCardTypes.REMOVE,
    };
};

export const fetchVirtualCard = (cardObj, payerId, token) => {

    let expDate = cardObj.expiryDate.split('/');
    let expYear = '20'+ expDate[1].replace(/\s/g, "");
    let newCardObj = {
        "cardNumber": cardObj.cardNumber.replace(/\s/g, ""),
        "cvc": cardObj.cvc,
        "expirationMonth": parseInt(expDate[0]),
        "expirationYear": parseInt(expYear),
        "token": token,
    }

    return dispatch => {


        let success = false
        const apiUrl = `/api/v1/createvirtualcard/`

        dispatch(requestVirtualCard());

        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-CSRFToken': getCookie("csrftoken"),
        }

        return fetch(apiUrl, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(newCardObj),
            credentials: 'include',
        })
        .then(parseJSON)
        .then(response => {
            if(response.isSuccess === true) {
                success = true
                let virtualCardObj = {
                    virtualCard: response.virtualCard,
                    cardNumber: newCardObj.cardNumber.substr(newCardObj.cardNumber.length - 4),
                    cardNumberMasked: `${newCardObj.cardNumber.substr(0, 6)}******${newCardObj.cardNumber.substr(newCardObj.cardNumber.length - 4)}`,
                    expirationMonth: newCardObj.expirationMonth,
                    expirationYear: newCardObj.expirationYear,
                }

                dispatch(storeTempCC( virtualCardObj, payerId))
                // dispatch(setInfoKey( {key: 'virtualCard', value: virtualCardObj }, customerId))
            }
            if (success) {
                dispatch(receiveVirtualCard(response));
            } else {
                dispatch(receiveVirtualCardError(response))
            }
        })
        .catch(handleNetworkError);
    };
};




export const requestSaveVirtualCard = () => {
    return {
        type: virtualCardTypes.REQUEST_SAVE,
    };
};

export const receiveSaveVirtualCard = (response) => {
    return {
        type: virtualCardTypes.RECEIVE_SAVE,
        data: response,
    };
};

export const receiveSaveVirtualCardError = (response) => {
    return {
        type: virtualCardTypes.ERROR_SAVE,
        error: response,
    };
};

export const fetchSaveVirtualCard = (cardObj, payerId, token) => {

    let newCardObj = {
        "virtualCard": cardObj.virtualCard,
        "expirationMonth": cardObj.expirationMonth,
        "expirationYear": cardObj.expirationYear,
        "cardNumberMasked": cardObj.cardNumber,
        "payerId": payerId,
    }

    let success = true

    return dispatch => {

        const apiUrl = `/api/v1/updatecreditcard/`

        dispatch(requestSaveVirtualCard());

        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-CSRFToken': getCookie("csrftoken"),
        }

        return fetch(apiUrl, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(newCardObj),
            credentials: 'include',
        })
        .then(response => {
            if (response.status !== 200) {
                success = false
            }
            return response
        })
        .then(parseJSON)
        .then(response => {
            if (success) {
                dispatch(receiveSaveVirtualCard(response));
            } else {
                dispatch(receiveSaveVirtualCardError(response))
            }
        })
        .catch(handleNetworkError);
    };
};


